import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Common";
import { useAuth } from "@/context/AuthContext";

function GoogleButton({ label }) {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const startGoogle = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button data-testid="auth-google-button" onClick={startGoogle}
      className="w-full flex items-center justify-center gap-3 h-12 rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] font-semibold hover:bg-[hsl(var(--muted))] transition-colors">
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 4.6 29.5 2.5 24 2.5 12.1 2.5 2.5 12.1 2.5 24S12.1 45.5 24 45.5 45.5 35.9 45.5 24c0-1.2-.1-2.3-.3-3.5z"/><path fill="#FF3D00" d="M4.7 14.7l6.6 4.8C13 16.1 18.1 12.5 24 12.5c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 4.6 29.5 2.5 24 2.5 15.9 2.5 8.9 7.1 4.7 14.7z"/><path fill="#4CAF50" d="M24 45.5c5.4 0 10.3-2.1 14-5.4l-6.5-5.5c-2 1.5-4.6 2.4-7.5 2.4-5.2 0-9.6-3.3-11.2-8l-6.5 5C8.8 40.8 15.8 45.5 24 45.5z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.5 5.5c-.5.4 6.7-4.9 6.7-15 0-1.2-.1-2.3-.3-3.5z"/></svg>
      {label}
    </button>
  );
}

export default function Login() {
  const { loginWithCredentials } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await loginWithCredentials(email, password);
      toast.success("Welcome back");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not sign in");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-4 py-10">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-6"><Logo /></div>
        <div className="rounded-2xl bg-[hsl(var(--card))] border border-[hsl(var(--border))] p-6 sm:p-8 shadow-[0_12px_30px_rgba(20,16,12,0.06)]">
          <h1 className="font-display text-2xl font-semibold text-center">Welcome back</h1>
          <p className="text-sm text-[hsl(var(--muted-foreground))] text-center mt-1">Sign in to manage your tributes</p>
          <div className="mt-6"><GoogleButton label="Continue with Google" /></div>
          <div className="flex items-center gap-3 my-5 text-xs text-[hsl(var(--muted-foreground))]"><div className="h-px flex-1 bg-[hsl(var(--border))]" />or<div className="h-px flex-1 bg-[hsl(var(--border))]" /></div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-sm font-medium">Email</label>
              <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full h-12 rounded-xl px-4 bg-[hsl(var(--background))] border border-[hsl(var(--input))] focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]" placeholder="you@example.com" />
            </div>
            <div>
              <label className="text-sm font-medium">Password</label>
              <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full h-12 rounded-xl px-4 bg-[hsl(var(--background))] border border-[hsl(var(--input))] focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]" placeholder="••••••••" />
            </div>
            <button data-testid="login-submit-button" disabled={loading} type="submit"
              className="w-full h-12 rounded-xl bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] font-semibold hover:opacity-90 transition-opacity disabled:opacity-60">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <p className="text-sm text-center mt-5 text-[hsl(var(--muted-foreground))]">New here? <Link to="/signup" className="font-semibold text-[hsl(var(--foreground))] underline">Create an account</Link></p>
        </div>
        <p className="text-xs text-center mt-4 text-[hsl(var(--muted-foreground))]">Demo: demo@gathervoices.io / demo1234</p>
      </div>
    </div>
  );
}
